import './damasio_logos.erb';
import './direcao_logos.erb';
import './images/damasio.svg';
import './index.scss';
import 'components/header_mobile_menu';
import 'components/header_mobile_user_menu';
import 'components/user/avatar';
import 'images/tracks/direcao-icon.svg';
import 'images/tracks/direcao.svg';

(function ($) {
  function init() {
    function handleOutsideClick(event, $element, $Toggle, $ToggleInput) {
      if (
        $(event.target).closest($element).length === 0 &&
        $(event.target).closest($Toggle).length === 0 &&
        $(event.target).closest($ToggleInput).length === 0 &&
        $element.length &&
        !$element.is(':hover')
      ) {
        $ToggleInput.prop('checked', false);
      }
    }

    $(document)
      .off('click.header')
      .on('click.header', event => {
        const $segmentsMenu = $('#js-segments-menu');
        const $segmentsMenuToggle = $('.js-segments-menu-toggle');
        const $segmentsMenuToggleInput = $('#segments-toggle-input');

        const $search = $('#js-header-search');
        const $searchToggle = $('.js-header-search-toggle');
        const $searchToggleInput = $('#search-toggle-input');

        handleOutsideClick(
          event,
          $segmentsMenu,
          $segmentsMenuToggle,
          $segmentsMenuToggleInput
        );
        handleOutsideClick(event, $search, $searchToggle, $searchToggleInput);
      });
  }

  $(document).on('turbolinks:load', () => {
    init();
  });
})(jQuery);
